import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import Login from "../views/Login.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: Login,
  },
  /*{
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/!* webpackChunkName: "about" *!/ '../views/AboutView.vue')
    },*/
  // Rotas do APP
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/lista-os",
    name: "listarOs",
    component: () => import("../views/ListaOS.vue"),
  },
  {
    path: "/detalhes-os",
    name: "detalhesOs",
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/monitor",
    name: "monitor",
    component: () => import("../views/Monitor.vue"),
  },
  {
    path: "/monitor-graficos",
    name: "MonitorCharts",
    component: () => import("../views/MonitorCharts.vue"),
  },
  {
    path: "/os-canceladas",
    name: "monitorCharts",
    component: () => import("../views/ListCancelledOS.vue"),
  },
  {
    path: "/nova-os",
    name: "NewOS",
    component: () => import("../views/NewOS.vue"),
  },
  {
    path: "/pesquisar-os/:id?",
    name: "SearchOS",
    component: () => import("../views/SearchOS.vue"),
  },
  {
    path: "/relatorio-dia/:day?",
    name: "DailyReport",
    component: () => import("../views/DailyReport.vue"),
  },
  {
    path: "/relatorio-mes",
    name: "MonthReport",
    component: () => import("../views/MonthReport.vue"),
  },
  {
    path: "/relatorio-atrasos",
    name: "LateDelivery",
    component: () => import("../views/Reports/LateDelivery.vue"),
  },
  {
    path: "/sistema/parametros",
    name: "systemParameters",
    component: () => import("../views/Admin/SystemParameters.vue"),
  },
  {
    path: "/sistema/usuarios",
    name: "systemUsers",
    component: () => import("../views/Admin/SystemUsers.vue"),
  },
  {
    path: "/sistema/servicos",
    name: "systemServices",
    component: () => import("../views/Admin/SystemServices.vue"),
  },
  {
    path: "/sistema/cores",
    name: "SystemColors",
    component: () => import("../views/Admin/SystemColors.vue"),
  },
  {
    path: "/sistema/veiculos",
    name: "SystemVehicles",
    component: () => import("../views/Admin/SystemVehicles.vue"),
  },
  {
    path: "/sistema/vendedores",
    name: "SystemSellers",
    component: () => import("../views/Admin/SystemSellers.vue"),
  },
  {
    path: "/sistema/feriados",
    name: "Holidays",
    component: () => import("../views/Admin/Holidays.vue"),
  },
  {
    path: "/sistema/prismas",
    name: "SystemPrism",
    component: () => import("../views/Admin/SystemPrism.vue"),
  },
  {
    path: "/sistema/horarios-novos",
    name: "ScheduleNewVehicles",
    component: () => import("../views/Admin/ScheduleNewVehicles.vue"),
  },
  {
    path: "/sistema/horarios-pos",
    name: "ScheduleUsedVehicles",
    component: () => import("../views/Admin/ScheduleUsedVehicles.vue"),
  },
  {
    path: "/sistema/horarios-lexus",
    name: "ScheduleLexusVehicles",
    component: () => import("../views/Admin/ScheduleLexus.vue"),
  },
  {
    path: "/sistema/dashboard",
    name: "Dashboard",
    component: () => import("../views/Admin/Dashboard.vue"),
  },
  {
    path: "/relatorio-servicos",
    name: "ServicesReport",
    component: () => import("../views/Reports/ServicesReport.vue"),
  },
  {
    path: "/relatorio-veiculos-novos",
    name: "NewVehicleReport",
    component: () => import("../views/Reports/NewVehicleReport.vue"),
  },
  {
    path: "/acompanhamento-diario",
    name: "DailyMonitoring",
    component: () => import("../views/Reports/DailyMonitoring.vue"),
  },
  {
    path: "/meu-perfil",
    name: "myProfile",
    component: () => import("../views/MyProfile.vue"),
  },
  {
    path: "/certificados",
    name: "Certificates",
    component: () => import("../views/Certificates/Home.vue"),
  },
  {
    path: "/certificados/historico",
    name: "CertificateHistory",
    component: () => import("../views/Certificates/History.vue"),
  },
  {
    path: "/certificados/marca-dagua",
    name: "Watermark",
    component: () => import("../views/Certificates/Watermark.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
